module.exports = __webpack_public_path__ + "img/TYS-3.def79fb2.jpg";